'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.getPropTypesMixin = getPropTypesMixin;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _lodashForOwn = require('lodash/forOwn');

var _lodashForOwn2 = _interopRequireDefault(_lodashForOwn);

function validateProp(validator, props, key, modelName) {
    var result = validator(props, key, modelName, 'prop');
    if (result instanceof Error) {
        throw result;
    }
}

function hasPropTypes(obj) {
    return typeof obj.propTypes === 'object';
}

function hasDefaultProps(obj) {
    return typeof obj.defaultProps === 'object';
}

function validateProps(props, propTypes, modelName) {
    (0, _lodashForOwn2['default'])(propTypes, function (validator, key) {
        validateProp(validator, props, key, modelName);
    });
}

function getPropTypesMixin(userOpts) {
    var opts = userOpts || {};

    var useValidation = undefined;

    if (opts.hasOwnProperty('validate')) {
        useValidation = opts.validate;
    } else if (process) {
        useValidation = process.env.NODE_ENV !== 'production';
    } else {
        useValidation = true;
    }

    var useDefaults = opts.hasOwnProperty('useDefaults') ? opts.useDefaults : true;

    return function (superclass) {
        return (function (_superclass) {
            _inherits(_class, _superclass);

            function _class() {
                _classCallCheck(this, _class);

                _get(Object.getPrototypeOf(_class.prototype), 'constructor', this).apply(this, arguments);
            }

            _createClass(_class, [{
                key: 'update',
                value: function update() {
                    var modelClass = this.getClass();

                    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    if (useValidation && hasPropTypes(modelClass)) {
                        (function () {
                            var props = args[0];

                            var propTypes = modelClass.propTypes;
                            var modelName = modelClass.modelName;

                            // Run validators for only the props passed in, not
                            // all declared PropTypes.
                            (0, _lodashForOwn2['default'])(props, function (val, key) {
                                if (propTypes.hasOwnProperty(key)) {
                                    var validator = propTypes[key];
                                    validateProp(validator, props, key, modelName + '.update');
                                }
                            });
                        })();
                    }

                    return _get(Object.getPrototypeOf(_class.prototype), 'update', this).apply(this, args);
                }
            }], [{
                key: 'create',
                value: function create() {
                    var _get2;

                    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                        args[_key2] = arguments[_key2];
                    }

                    var props = args[0];
                    var rest = args.slice(1);

                    var defaults = useDefaults && hasDefaultProps(this) ? this.defaultProps : {};

                    var propsWithDefaults = Object.assign({}, defaults, props);

                    if (useValidation && hasPropTypes(this)) {
                        validateProps(propsWithDefaults, this.propTypes, this.modelName + '.create');
                    }

                    return (_get2 = _get(Object.getPrototypeOf(_class), 'create', this)).call.apply(_get2, [this, propsWithDefaults].concat(_toConsumableArray(rest)));
                }
            }]);

            return _class;
        })(superclass);
    };
}

exports['default'] = getPropTypesMixin();


/*****************
 ** WEBPACK FOOTER
 ** ./~/redux-orm-proptypes/lib/index.js
 ** module id = 576
 ** module chunks = 0
 **/